import { Link, useParams } from 'react-router-dom';
import MediaCard from '@/components/feature/MediaCard';
import { specials } from '@/mocks/specials';
import { getMediaByIds, getSpecialById } from '@/utils/media';

export default function SpecialDetail() {
  const { id } = useParams<{ id: string }>();
  const special = id ? getSpecialById(id) : undefined;

  if (!special) {
    return (
      <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-400">
          <i className="ri-gallery-view-2 text-3xl"></i>
        </span>
        <h1 className="mt-4 text-xl font-bold text-foreground-800">没有找到该专题</h1>
        <p className="mt-1 text-sm text-foreground-500">专题可能已下线，去看看其他合集吧</p>
        <Link
          to="/special"
          className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
        >
          返回专题合集
        </Link>
      </div>
    );
  }

  const items = getMediaByIds(special.mediaIds);
  const otherSpecials = specials.filter((s) => s.id !== special.id);

  return (
    <div className="w-full">
      <section className="relative h-[280px] w-full overflow-hidden md:h-[340px]">
        <img
          src={special.cover}
          alt={`${special.title} 专题大图`}
          title={`${special.title} 精选片单`}
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20"></div>
        <div className="absolute inset-0">
          <div className="mx-auto flex h-full w-full flex-col justify-end px-4 pb-8 md:px-6 md:pb-10">
            <nav className="mb-3 flex flex-wrap items-center gap-2 text-sm text-white/70">
              <Link to="/" className="hover:text-white">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <Link to="/special" className="hover:text-white">专题合集</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white">{special.title}</span>
            </nav>
            <h1 className="font-heading text-3xl font-bold text-white md:text-4xl">{special.title}</h1>
            <p className="mt-2 text-sm text-white/85 md:text-base">{special.subtitle}</p>
          </div>
        </div>
      </section>

      <div className="mx-auto w-full px-4 py-8 md:px-6">
        <div className="mb-8 rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
          <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <i className="ri-bookmark-line text-primary-500"></i> 专题导语
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-700">{special.description}</p>
        </div>

        <section>
          <h2 className="mb-4 font-heading text-xl font-bold text-foreground-950">
            精选片单 <span className="text-sm font-normal text-foreground-500">({items.length} 部)</span>
          </h2>
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
            {items.map((item) => (
              <MediaCard key={item.id} item={item} />
            ))}
          </div>
        </section>

        {otherSpecials.length > 0 && (
          <section className="mt-12">
            <h2 className="mb-4 font-heading text-xl font-bold text-foreground-950">其他专题</h2>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
              {otherSpecials.map((s) => (
                <Link
                  key={s.id}
                  to={`/special/${s.id}`}
                  className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 hover:border-primary-200"
                >
                  <div className="relative h-28 w-full overflow-hidden bg-background-200">
                    <img src={s.cover} alt={s.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <p className="absolute bottom-2 left-3 text-sm font-bold text-white">{s.title}</p>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}